import { useEffect, useState } from 'react'

import { useBogo } from '@mc/bogo-utils'
import { BREAKPOINTS } from '@mc/media'

import { StickyConfig } from 'components/Sticky/useSticky'

export const useConfig = () => {
  const [config, setConfig] = useState<StickyConfig>()
  const { isBogoOfferEligible } = useBogo()

  useEffect(() => {
    const width = window?.innerWidth
    const ltMD = width < BREAKPOINTS.MD

    if (isBogoOfferEligible) {
      // PEN-2481:
      // it means the bogo banner is visible, so, the sticky footer must not be
      // shown immediately after users scroll
      setConfig({ topBuffer: ltMD ? 120 : 65 })
    }
  }, [isBogoOfferEligible])

  return { config }
}
